import React from 'react';
let RegistrationState = {
};
const getContext =()=> {
    const RegistrationStateContext = React.createContext(RegistrationState);
    return RegistrationStateContext;
}

const RegistrationContext = getContext();

export default RegistrationContext;
